
import Order from './order.vue'
import Xorder from './xorder.vue'
import Torder from './torder.vue'


export default {
	Order,
	Xorder,
	Torder,
}



// WEBPACK FOOTER //
// ./src/views/order/index.js